import styled from 'styled-components';

interface ChunkProps {
  barHeight: number;
  isBought: boolean;
}

export const WaveformContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #555555;
  height: 100px;
  align-items: center;
  padding: 0px 3px;
  justify-content: space-evenly;
`;

export const WaveformChunkBar = styled.div<ChunkProps>`
  height: ${(props) => (props.barHeight >= 80 ? 80 : props.barHeight)}px;
  width: 3px;
  background-color: ${(props) => (props.isBought ? '#ea6343' : '#9b9b9b')};
  position: relative;

  &:hover {
    background-color: #ea6343;
    cursor: ${(props) => (props.isBought ? 'default' : 'pointer')};
  }
`;

export const ChunckBarBoughtInfo = styled.div`
  z-index: 100;
  color: #fff;
  background-color: black;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  text-align: center;
  width: 200px;
  bottom: -105px;
  padding: 5px;
  border-radius: 4px;

  transform: translate(-50%);

  transition: 0.25s all ease;
  transition-delay: 0.25s;

  &:after {
    position: absolute;
    top: 0;
    left: 50%;
    content: '';
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent black transparent;
    border-style: solid;
    transform: translate(-42%, -100%);
  }
`;

export const WaveformChunkContainer = styled.div`
  position: relative;

  &:hover ${ChunckBarBoughtInfo} {
    visibility: visible;
    opacity: 1;
    transition: 0.25s all ease;
    transition-delay: 0.25s;
  }
`;
